import apiClient from './apiClient';

export interface QueryParams {
  deptFrom?: string;
  deptTo?: string;
  empFrom?: string;
  empTo?: string;
}

export interface DeptStats {
  dept_code: string;
  dept_name: string;
  total_count: number;
  male_count: number;
  female_count: number;
  married_male: number;
  unmarried_male: number;
  married_female: number;
  unmarried_female: number;
  avg_age_male: number;
  avg_age_female: number;
  avg_sen_male: number;
  avg_sen_female: number;
}

export interface CompanyTotals {
  total_count: number;
  male_count: number;
  female_count: number;
  married_male: number;
  unmarried_male: number;
  married_female: number;
  unmarried_female: number;
  avg_age: number;
  avg_seniority: number;
  avg_age_male: number;
  avg_age_female: number;
  avg_sen_male: number;
  avg_sen_female: number;
}

export interface QueryResponse {
  data: DeptStats[];
  totals: CompanyTotals;
  message?: string;
}

export const pw930bApi = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw930b/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw930b/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
